exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colorPicker .colorPickerController{padding:5px;margin-top:4px;display:flex;align-items:center;justify-content:space-between;border-radius:4px}.colorPicker .cellIcon .Icon svg{height:100%}.colorPicker .cell-container:disabled{cursor:no-drop;opacity:.5}.colorPicker .cell-container.cell-tool:not([disabled]):hover{border:none;box-shadow:var(--colorpicker-tool-shadow);background:var(--colorpicker-tool-bg);border-radius:4px}", ""]);

// exports
